import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/modules/shared/services/geral/app.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tipo-processo',
  templateUrl: './tipo-processo.component.html',
  styleUrls: ['./tipo-processo.component.css']
})

export class TipoProcessoComponent implements OnInit {

  constructor(public svc: AppService, private router: Router, private tl: TranslateService) {
  }

  public tipo_manutencao: string;
  public cols: any[];
  public processos: any[];
  public spinProcesso = true;
  public spinProcessoCRUD = false;

  public sbRetornarFiltros(lista: any[], column: string): any {
    var retorno = [];

    if (lista) {
      for (let i = 0; i < lista.length; i++) {
        retorno.push(lista[i][column]);
      }

      retorno = retorno.filter(function (value, index) { return retorno.indexOf(value) == index });

      for (let i = 0; i < retorno.length; i++) {
        retorno[i] = { label: retorno[i], value: retorno[i] }
      }
    }

    return retorno;
  }

  public novo_tipo_processo: any = {
    id_processo: -1,
    nome_processo: "",
    momento_assinatura_id: "",
    limite: "",
    valor_minimo_assinatura: "0",
    perfis_acesso: [],
    tipos_assinaturas: []
  };

  public perfis_acesso: any[] = [];
  public momentos_assinatura: any[] = [];
  public tipos_assinaturas: any[] = [];

  public ajustarBoolean(texto: string): boolean {
    texto = texto.toLowerCase();
    if (texto == "sim") {
      return true;
    } else {
      return false;
    }
  }

  public limparForm(f: NgForm, data) {
    this.perfis_acesso.forEach(function (item: any) {
      item["fl"] = false;
    });

    this.tipos_assinaturas.forEach(function (item: any) {
      item["fl"] = false;
    });

    f.reset();

    var that = this;
    setTimeout(() => {
      if (data == null) {
        that.novo_tipo_processo = {
          id_processo: -1,
          nome_processo: "",
          momento_assinatura_id: "",
          limite: "",
          valor_minimo_assinatura: "0",
          perfis_acesso: [],
          tipos_assinaturas: []
        };
      } else {
        that.novo_tipo_processo = data;

        if (that.novo_tipo_processo["perfis_acesso"] != undefined) {
          that.novo_tipo_processo["perfis_acesso"].forEach(function (item: any) {
            that.perfis_acesso.forEach(function (item2: any) {
              if (item["id_perfil_acesso"] == item2["id_perfil"]) {
                item2["fl"] = true;
              }
            });
          });
        }
        if (that.novo_tipo_processo["tipos_assinaturas"] != undefined) {
          that.novo_tipo_processo["tipos_assinaturas"].forEach(function (item: any) {
            that.tipos_assinaturas.forEach(function (item2: any) {
              if (item["id_tipo_assinatura"] == item2["id_tipo_assinatura"]) {
                item2["fl"] = true;
              }
            });
          });
        }
      }
    }, 100);
  }

  public sbAbrirModal(event: Event): void {
    try {
      var id = $(event.target).attr("data-modal");
      this.svc.sbAbrirModal(id);
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  };

  public sbAbrirTipoProcesso(event: Event, f: NgForm): void {
    try {
      this.tipo_manutencao = "I";
      this.limparForm(f, null);

      var id = $(event.target).attr("data-modal");
      this.svc.sbAbrirModal(id);
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  };

  public sbCarregarIdioma() {
    this.cols = [
      { type: 'edit', filter: false, filter_type: 'multi-select', header: '', field: 'id_processo', size: '4%' },
      { type: 'remove', filter: false, filter_type: 'multi-select', header: '', field: 'id_processo', size: '4%' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("tipos_processo_tabela.nome"), field: 'nome_processo', size: '45%' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("tipos_processo_tabela.momento_assinatura"), field: 'momento_assinatura_desc', size: '31%' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: this.tl.instant("tipos_processo_tabela.limite"), field: 'limite', size: '15%' }
    ];
  }

  //Processar Dados
  public salvarProcesso(f: NgForm) {
    try {
      //Verifica se o FOrmulário está Válido
      if (f.valid) {
        let that = this;
        this.novo_tipo_processo["perfis_acesso"] = [];
        this.perfis_acesso.forEach(function (item: any) {
          if (item["fl"] == true) {
            that.novo_tipo_processo["perfis_acesso"].push({ "id_perfil_acesso": item.id_perfil });
          }
        });

        this.novo_tipo_processo["tipos_assinaturas"] = [];
        this.tipos_assinaturas.forEach(function (item: any) {
          if (item["fl"] == true) {
            that.novo_tipo_processo["tipos_assinaturas"].push({ "id_tipo_assinatura": item.id_tipo_assinatura });
          }
        });

        this.novo_tipo_processo.limite = this.ajustarBoolean(this.novo_tipo_processo.limite);
        this.novo_tipo_processo.valor_minimo_assinatura = parseInt(this.svc.fnRemoverMascara(this.novo_tipo_processo.valor_minimo_assinatura));

        if (this.tipo_manutencao == "I") {
          this.incluirProcesso(this.novo_tipo_processo);
        } else {
          this.alterarProcesso(this.novo_tipo_processo);
        }
      } else {
        //Marca todos os campos como Inválidos
        (<any>Object).values(f.controls).forEach(control => {
          control.markAsTouched();
        });
        this.svc.sbExibirNotificacao("warning", this.tl.instant("geral.mensagens.atencao"), this.tl.instant("geral.campos_obrigatorios"));
      }
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  //Processar Dados
  public excluirProcesso() {
    try {
      let that = this;
      this.novo_tipo_processo["perfis_acesso"] = [];
      this.perfis_acesso.forEach(function (item: any) {
        if (item["fl"] == true) {
          that.novo_tipo_processo["perfis_acesso"].push({ "id_perfil_acesso": item.id_perfil });
        }
      });

      this.novo_tipo_processo["tipos_assinaturas"] = [];
      this.tipos_assinaturas.forEach(function (item: any) {
        if (item["fl"] == true) {
          that.novo_tipo_processo["tipos_assinaturas"].push({ "id_tipo_assinatura": item.id_tipo_assinatura });
        }
      });

      this.novo_tipo_processo.limite = this.ajustarBoolean(this.novo_tipo_processo.limite);
      this.novo_tipo_processo.valor_minimo_assinatura = parseInt(this.svc.fnRemoverMascara(this.novo_tipo_processo.valor_minimo_assinatura));

      this.spinProcessoCRUD = true;
      this.svc.ExcluirTipoProcesso(this.novo_tipo_processo);
      this.svc.TipoProcessoExcluido().subscribe((resp) => {
        if (resp == false) this.spinProcessoCRUD = false;
        else if (resp != null) {
          this.spinProcessoCRUD = false;
          this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.excluido"), this.tl.instant("tipos_processo.mensagem.excluir_processo"));
          this.carregarProcessos();
        }
      });

      this.svc.sbFecharModal("modalTipoProcesso");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  //Remover Dados
  public removerProcesso(data, f: NgForm) {
    try {
      this.limparForm(f, Object.assign({}, data));
      this.tipo_manutencao = "E";
      this.svc.sbAbrirModal("modalTipoProcesso");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  //Editar Dados
  public editarProcesso(data, f: NgForm) {
    try {
      this.limparForm(f, Object.assign({}, data));
      this.tipo_manutencao = "A";
      this.svc.sbAbrirModal("modalTipoProcesso");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  //Carregar Dados
  public carregarProcessos() {
    try {
      this.spinProcesso = true;
      this.svc.TipoProcessoPesquisar();
      this.svc.TipoProcesso().subscribe((resp) => {
        if (resp == false) this.spinProcesso = false;
        else if (resp != null){
          this.spinProcesso = false;
          this.processos = resp.Processos;
        }
      });
    } catch (e) {
      throw e;
    }
  }

  public checkAll(event, tipo) {
    if (tipo == "perfis") {
      this.perfis_acesso.forEach((item, index) => {
        this.perfis_acesso[index].fl = event.target.checked;
      });
    } else {
      this.tipos_assinaturas.forEach((item, index) => {
        this.tipos_assinaturas[index].fl = event.target.checked;
      });
    }
  }

  //Carregar Dados
  public carregarPerfisAcesso() {
    try {
      this.svc.PerfisAcessoPesquisar();
      this.svc.CadastroPerfisAcesso().subscribe((resp) => {
        if (resp != null) {
          resp.forEach(item => {
            item.fl = false;
          });
          this.perfis_acesso = resp;
        }
      });
    } catch (e) {
      throw e;
    }
  }

  //Carregar Dados
  public carregarMomentosAssinatura() {
    try {
      this.svc.MomentosAssinaturaPesquisar();
      this.svc.CadastroMomentosAssinatura().subscribe((resp) => {
        if (resp != null) 
          this.momentos_assinatura = resp;
      });
    } catch (e) {
      throw e;
    }
  }

  //Carregar Dados
  public carregarTiposAssinatura() {
    try {
      this.svc.TiposAssinaturaPesquisar();
      this.svc.CadastroTiposAssinatura().subscribe((resp) => {
        if (resp != null)
          this.tipos_assinaturas = resp;
      });
    } catch (e) {
      throw e;
    }
  }

  //Insere Tipo Processo
  public incluirProcesso(tipoProcesso: any) {
    try {
      this.spinProcessoCRUD = true;
      this.svc.InserirTipoProcesso(tipoProcesso);
      this.svc.TipoProcessoIncluido().subscribe((resp) => {
        if (resp == false) this.spinProcessoCRUD = false;
        else if (resp != null) {
          this.spinProcessoCRUD = false;
          this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("tipos_processo.mensagem.salvar_processo"));
          this.carregarProcessos();
          this.svc.sbFecharModal("modalTipoProcesso");
        }
      });
    } catch (e) {
      throw e;
    }
  }

  //Altera Tipo Processo
  public alterarProcesso(tipoProcesso: any) {
    try {
      this.spinProcessoCRUD = true;
      this.svc.AlterarTipoProcesso(tipoProcesso);
      this.svc.TipoProcessoAlterado().subscribe((resp) => {
        if (resp == false) this.spinProcessoCRUD = false;
        else if (resp != null) {
          this.spinProcessoCRUD = false;
          this.svc.sbExibirNotificacao("success", this.tl.instant("geral.mensagens.salvo"), this.tl.instant("tipos_processo.mensagem.alterar_processo"));
          this.carregarProcessos();
          this.svc.sbFecharModal("modalTipoProcesso");
        }
      });
    } catch (e) {
      throw e;
    }
  }

  ngOnInit() {
    try {
      this.carregarProcessos();
      this.carregarPerfisAcesso();
      this.carregarMomentosAssinatura();
      this.carregarTiposAssinatura();

      //É chamado sempre que o Idioma for Mudado
      this.svc.sbGetTraducaoAuto("tipos_processo_tabela").subscribe((resp) => {
        this.sbCarregarIdioma();
      });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

}
